/**
 * Created by htz on 2024/8/19.
 *@
 */
import $ from 'jquery'
export function ChengBenZhongXin(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'ChengBenZhongXin',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}

export function HeTongLeiXing(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'HeTongLeiXing',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}
export function UserOrg(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'userOrg',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}
export function User(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'user',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}

export function elInput(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'el-input',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}

export function elSelect(label = '', required = true, attrs = {}, slots = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'el-select',error:'请输入',
      ...prop,
      label, required, attrs, slots
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}

export function richText(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'my-rich-text',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}

export function upload(label = '', required = true, attrs = {}, prop = {}) {
  let ret= {
    editor: {
      cmpName: 'my-upload',error:'请输入',
      ...prop,
      label, required, attrs
    }
  }
  if(arguments.length==2&&typeof required=='object'){
    $.extend(true,ret,{editor:{...required}})
  }
  return ret;
}

export default {
  elInput,
  elSelect,
  ChengBenZhongXin,
  HeTongLeiXing,
  UserOrg,
  User,
  richText,
  upload,
}



// WEBPACK FOOTER //
// ./src/utils/editors.js